module.exports = __webpack_public_path__ + "img/far-check.e3cc5e2c.svg";